module.exports = __webpack_public_path__ + "static/img/Geoffroy-Guichard-Stadium.0dc04ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Geoffroy-Guichard-Stadium.jpg
// module id = 6vKo
// module chunks = 0